module.exports = __webpack_public_path__ + "img/Planbook(5).68e89027.png";